import React, { Component } from 'react';
import BaseLayout from './../../templates/base'
import Form from './../../elements/versions/form';
import Loading from "../../elements/loading";
import VersionsAdd from './../../elements/versions/widget/versions_add';

class VersionsForm extends Component {
	render() {
		const { versions, groupsPhases } = this.props;
		return (
			(groupsPhases.isFetching || versions.isFetching ) ? <Loading/>:<Form {...this.props}/>
		)
	}

	componentWillMount() {
		this.props.resetVersions();
		this.props.fetchGroupsPhasesList();
	}
}

export default BaseLayout(VersionsForm, {
	title:`Crear Versión`,
	subnav: {
		icon: 'fa fa-calendar-check-o',
		name: 'Versiones',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <VersionsAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/versions/create.jsx